import axios from '@/plugins/axios';
import { PAGE_SIZE } from '@/constants/dbConstant';

const NOTIFICATION = '/notifications';

export async function getNotificationPerPage(payload) {
  try {
    const queryString = `page=${payload.current}&size=${PAGE_SIZE}${!payload.read_flag ? `&read_flag=${payload.read_flag}` : ''}`;
    const { data } = await axios.get(`${NOTIFICATION}?${queryString}`);
    return data;
  } catch (error) {
    return { error };
  }
}

export async function updateNotification(form) {
  try {
    const { data } = await axios.put(`${NOTIFICATION}/${form.id}`, form);
    return data;
  } catch (error) {
    return { error };
  }
}

export async function deleteNotification(payload) {
  try {
    const { data } = await axios.delete(`${NOTIFICATION}/${payload}`);
    return data;
  } catch (error) {
    return { error };
  }
}

export async function sendNotificationToUser(payload) {
  try {
    const { data } = await axios.put(`${NOTIFICATION}/send_notification/user`, payload);
    return data;
  } catch (error) {
    return { error };
  }
}
